<template>
  <article class="NewsArticle"
    :class="classes">

    <header class="NewsArticle-header">

      <h2 class="t-heading-md">

        <component class="NewsArticle-title"
          :is="route ? 'router-link' : 'span'"
          :to="route">

          {{ post.attributes.title }}

        </component>

      </h2>

      <p class="NewsArticle-date t-text-sm"
        v-if="showDate">
        {{ post.attributes.date | formatDate('mmmm d, yyyy') }}
      </p>

    </header>

    <main class="NewsArticle-main">

      <markdown class="NewsArticle-content"
        :content="content"
        :attributes="post.attributes" />

    </main>

    <footer class="NewsArticle-footer"
      v-if="post.excerpt && collapsePost">

      <div class="NewsArticle-readMore"
        v-if="post.excerpt"
        @click="toggleFullPost">

        <read-more-button class="NewsArticle-readMoreButton"
          :label="showFullPost ? 'Read less' : 'Read more'"
          :icon="showFullPost ? 'arrow-up' : 'arrow-down'" />

      </div>

    </footer>

  </article>
</template>

<script>
export default {
  name: 'NewsArticle',

  props: {
    post: {
      type: Object,
      required: true
    },
    route: { // Pass in a route object to link to the single post
      type: Object
    },
    collapsePost: {
      type: Boolean,
      default: false
    },
    showDate: {
      type: Boolean,
      default: false
    },
    showRule: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      showFullPost: true,
      markedWindowPosition: 0
    }
  },

  computed: {
    /**
     * Classes for the main element
     * @return {Object}
     */
    classes () {
      return {
        'NewsArticle--showRule': this.showRule
      }
    },

    /**
     * Content for the content area
     * @return {String}
     */
    content () {
      if (this.post.excerpt && !this.showFullPost) return this.post.excerpt
      return this.post.body
    }
  },

  created () {
    this.showFullPost = !this.collapsePost
  },

  methods: {
    /**
     * Toggle show full post state
     */
    toggleFullPost () {
      if (!this.showFullPost) {
        this.showFullPost = true
        this.markedWindowPosition = window.scrollY
        return
      }

      this.showFullPost = false
      window.scrollTo(0, this.markedWindowPosition)
      this.markedWindowPosition = 0
    }
  }
}
</script>

<style>
@import 'properties';

.NewsArticle {

  @media (min-width: 600px) {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-column-gap: 24px;
  }
}

.NewsArticle-header {
  margin-bottom: 24px;
}

.NewsArticle-main {
  @media (min-width: 600px) {
    grid-row: span 2;
  }
}

.NewsArticle--showRule .NewsArticle-main {

  @media (min-width: 600px) {
    padding-bottom: 24px;
    border-bottom: 1px solid var(--c-grey-xxlt);
  }
}

.NewsArticle-content {
  margin-bottom: -4px;
}

/* Make paragraphs that lead the post even with the post title */
.NewsArticle-content .Markdown-content p:first-child {
  margin-top: -6px;
}

.NewsArticle-title {
  display: block;
  margin-top: -5px;
  margin-bottom: -8px;
  color: inherit;
}

.NewsArticle-date {
  margin-top: 9px;
  margin-bottom: -9px;

  @media (min-width: 600px) {
    margin-top: 21px;
  }
}

.NewsArticle-footer {

  @media (min-width: 600px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
}

.NewsArticle--showRule .NewsArticle-footer {

  @media (max-width: 599px) {
    padding-bottom: 24px;
    border-bottom: 1px solid var(--c-grey-xxlt);
  }
}

.NewsArticle-readMore {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 24px;

  @media (min-width: 600px) {
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// NewsArticle.vue?412c3756